<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div *ngIf="this.label != null" class="row">
    <div class="col-md-9">
        <div class="form-label">{{this.label}}<span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span></div>
    </div>
    <div *ngIf="this.subText != null" class="col-md-12">
      <div [innerHTML]="this.subText"></div>
    </div>
  </div>
  <div class="row mt-{{LABEL_SPACING}}">
    <div class="col">
        <textarea 
          id="{{this.propertyId}}" 
          class="form-control textbox-input"
          [ngClass]="[(this.isInvalid()) ? 'is-invalid' : '']"
          type="text" 
          maxlength={{this.maxLength}} 
          formControlName="{{this.propertyName}}">
        </textarea>
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
  <div class="row">
    <div class="col-12 mt-10">
        <span class="textbox-characters-avaliable">{{ 250 - (this.formGroup.get(propertyName).value ? this.formGroup.get(propertyName).value.length : 0)}} characters available</span>
    </div>
  </div>
</div>
